import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["style"];
export default function convertOutput(component) {
  var properties = component.properties;
  var _ref = properties,
    style = _ref.style,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return {
    brick: "pre",
    properties: _objectSpread({
      style: _objectSpread({
        background: "hsl(230, 1%, 98%)",
        color: "hsl(230, 8%, 24%)",
        fontFamily: '"Fira Code", "Fira Mono", Menlo, Consolas, "DejaVu Sans Mono", monospace',
        direction: "ltr",
        textAlign: "left",
        whiteSpace: "pre",
        wordSpacing: "normal",
        wordBreak: "normal",
        lineHeight: "1.5",
        tabSize: "2",
        hyphens: "none",
        fontSize: "13px",
        padding: "1em",
        // margin: "0.5em 0",
        margin: "0",
        overflowX: "auto",
        borderRadius: "9px"
      }, style)
    }, restProps)
  };
}
//# sourceMappingURL=convertOutput.js.map